// Exam quiz in a dialog (shopify-theme#238) — the small trigger module.
// Markup: snippets/fstv-exam-quiz-dialog.liquid (one dialog per page).
//
// Any link to the article quel-examen-de-francais-choisir opens the dialog on
// its choice screen, except inside [data-xq-no-dialog] (the homepage blog
// feed: a post card is a choice to read the article). The link's href stays the article, so without JS (or if
// this module fails) the link just navigates. The quiz itself
// (fstv-exam-quiz.js) is imported on the first « Faire le quiz » click.
//
// The page decides its placement (placementFor, unit-tested):
//   homepage → quiz-accueil, capture on
//   collections → quiz-collection-examens / quiz-tous-les-cours / quiz-collection
//   the 4 exam sales pages → no capture, current = the page's exam (R5):
//     « C'est ce cours → » closes the dialog and scrolls to #acheter. It never
//     clicks « Acheter », so the buy-gate dialog stays its own.

export const GUIDE_PATH = '/blogs/blog/quel-examen-de-francais-choisir';

const STORE_HOST = /(^|\.)frenchschooltv\.com$/;

/** True for a link to the exam guide article (any query or hash, our own hosts only). */
export function isGuideLink(href, origin) {
  if (!href) return false;
  let u;
  try { u = new URL(href, origin); } catch { return false; }
  const home = new URL(origin);
  if (u.host !== home.host && !STORE_HOST.test(u.hostname)) return false;
  return u.pathname.replace(/\/+$/, '') === GUIDE_PATH;
}

export const EXAM_PRODUCTS = {
  'preparez-vous-pour-le-delf-b2': 'delfb2',
  'preparez-vous-pour-le-dalf-c1': 'dalfc1',
  'preparez-vous-pour-le-tcf': 'tcf',
  'preparez-vous-pour-le-tef': 'tef',
};

const COLLECTION_PLACES = {
  'cours-de-preparation-aux-examens': 'collection-examens',
  'tous-les-cours': 'tous-les-cours',
};

/** The quiz options for a page, or null where the dialog doesn't run. */
export function placementFor(type, handle) {
  if (type === 'index') return { place: 'accueil', capture: true, current: '' };
  if (type === 'collection') {
    return { place: Object.hasOwn(COLLECTION_PLACES, handle) ? COLLECTION_PLACES[handle] : 'collection', capture: true, current: '' };
  }
  // A sales page never captures: its only ask stays the purchase.
  if (type === 'product' && Object.hasOwn(EXAM_PRODUCTS, handle)) {
    return { place: '', capture: false, current: EXAM_PRODUCTS[handle] };
  }
  return null;
}

export function initQuizDialog(dlg) {
  if (!dlg || typeof dlg.showModal !== 'function') return; // no <dialog>: links navigate
  const opts = placementFor(dlg.dataset.pageType, dlg.dataset.pageHandle);
  if (!opts) return;

  const choice = dlg.querySelector('[data-xq-choice]');
  const quiz = dlg.querySelector('[data-fstv-xq]');
  const start = dlg.querySelector('[data-xq-start]');
  const guide = dlg.querySelector('[data-xq-guide]');
  quiz.dataset.xqPlace = opts.place;
  quiz.dataset.xqCapture = String(opts.capture);
  quiz.dataset.xqCurrent = opts.current;

  let trigger = null;
  let toBuyBox = false;
  let loading = null;

  function showChoice() {
    choice.hidden = false;
    quiz.hidden = true;
    dlg.setAttribute('aria-labelledby', 'fstv-xq-dlg-title');
  }

  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a || dlg.contains(a) || a.closest('[data-xq-no-dialog]')) return;
    if (!isGuideLink(a.getAttribute('href'), location.origin)) return;
    if (document.querySelector('dialog[open]')) return; // never stack on another dialog
    e.preventDefault();
    trigger = a;
    toBuyBox = false;
    showChoice();
    dlg.showModal();
    start.focus();
  });

  start.addEventListener('click', () => {
    loading ||= import(dlg.dataset.quizSrc);
    start.disabled = true;
    loading.then((m) => {
      m.mount(quiz);
      choice.hidden = true;
      quiz.hidden = false;
      dlg.setAttribute('aria-labelledby', 'fstv-xq-dlg-kicker');
      const q = quiz.querySelector('.xq__q, .xq__verdict');
      if (q) q.focus();
    }).catch(() => {
      window.location.href = guide.href; // the module failed: the guide still answers
    }).finally(() => { start.disabled = false; });
  });

  dlg.querySelector('[data-xq-close]').addEventListener('click', () => dlg.close());
  dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); }); // backdrop
  quiz.addEventListener('fstv-xq:this', () => { toBuyBox = true; dlg.close(); });

  dlg.addEventListener('close', () => {
    const buy = toBuyBox && document.getElementById('acheter');
    if (buy) {
      const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      buy.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
      if (!buy.hasAttribute('tabindex')) buy.setAttribute('tabindex', '-1');
      buy.focus({ preventScroll: true }); // keyboard users land on the buy box too
    } else if (trigger) {
      trigger.focus();
    }
    toBuyBox = false;
  });
}

if (typeof document !== 'undefined') {
  initQuizDialog(document.getElementById('fstv-xq-dialog'));
}
